import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ProductCard from '@/components/feature/ProductCard';
import {
  KASPREADSHEET_PRODUCTS,
  PRODUCT_CATEGORIES,
} from '@/mocks/kaspreadsheet-products';

export default function FeaturedProductsSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';
  const [activeCategory, setActiveCategory] = useState<string>(PRODUCT_CATEGORIES[0]);

  const categoryProducts = KASPREADSHEET_PRODUCTS.filter(
    (p) => p.category === activeCategory
  ).slice(0, 8);

  return (
    <section id="products" className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
            {t('featuredProducts.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl">
            {t('featuredProducts.subtitle')}
          </p>
        </div>
        <a
          href={`/${currentLang}/products`}
          className="hidden md:inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
        >
          {t('featuredProducts.viewAll')}
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      {/* Category tabs */}
      <div className="flex items-center gap-2 overflow-x-auto pb-3 mb-6 scrollbar-hide">
        {PRODUCT_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-2 text-sm font-semibold rounded-full whitespace-nowrap transition-colors ${
              activeCategory === cat
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Product grid - 4 columns on desktop, 2 on mobile */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categoryProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {/* Mobile view all button */}
      <div className="mt-6 text-center md:hidden">
        <a
          href={`/${currentLang}/products`}
          className="inline-flex items-center gap-1.5 px-5 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors"
        >
          {t('featuredProducts.viewAll')}
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}